import { render, staticRenderFns } from "./CreateOffer.vue?vue&type=template&id=45831918&"
import script from "./CreateOffer.vue?vue&type=script&lang=js&"
export * from "./CreateOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports